import { useAuthStatusQuery } from '../queries/auth'
import { useAuth } from './useAuth'
import { useEffect } from 'react'

/**
 * 認証状態を監視し、トークンの有効期限が近い場合に自動更新するフック
 */
export function useTokenRefreshMonitor() {
  const { data: authStatus, refetch } = useAuthStatusQuery()
  const { isAuthenticated, login } = useAuth()

  useEffect(() => {
    if (!isAuthenticated) return

    // 40分間隔でプリエンプティブにトークンをリフレッシュ
    // (Microsoft Graph tokenの標準有効期限60分より前に実行)
    const refreshInterval = setInterval(async () => {
      try {
        const result = await refetch()
        if (!result.data?.authenticated) {
          // 自動リフレッシュが失敗した場合、再ログインを促す
          console.warn('Token refresh failed, redirecting to login')
          login()
        }
      } catch (error) {
        console.error('Token refresh error:', error)
      }
    }, 5 * 60 * 1000) // 5分

    return () => clearInterval(refreshInterval)
  }, [isAuthenticated, refetch, login])

  return { authStatus, isAuthenticated }
}
